// @core/api/endpoints/payment/refund_entity.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PaymentLifecycleResponse,
  RefundEntityRequest,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Refund entity payment
 * Initiates a full or partial refund for any entity with payment aspect. Updates payment aspect with refunded amounts.
 */
export async function RefundEntity(
  target_type: string,
  target_id: string,
  data: RefundEntityRequest,
  options?: RequestOptions
): Promise<PaymentLifecycleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/payment/:target_type/:target_id/refund`;
  requestPath = requestPath.replace(':target_type', encodeURIComponent(target_type));
  requestPath = requestPath.replace(':target_id', encodeURIComponent(target_id));
  const requestOptions = options;
  return client.post<PaymentLifecycleResponse>(requestPath, data, requestOptions);
}
